export default "__VITE_ASSET__74819d2a__"